export default __webpack_public_path__ + "static/media/3.284c92eb.jpeg";